// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ActivatePaymentRuleResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/activate_payment_rule endpoint
 *
 * Action endpoint — confirms successful activation of a payment rule.
 * No payload: dados is always null on success; failures route through
 * sendError() and never reach this contract.
 *
 * @see Payroll::activate_payment_rule() controller
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_ActivatePaymentRuleResponseDados = null;

export type Payroll_ActivatePaymentRuleResponse = ApiResponse<Payroll_ActivatePaymentRuleResponseDados>;

registerResponseContract('Payroll_ActivatePaymentRuleResponse', {})
